import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { logOut } from '../actions/user';

import { translations, locales, setLocale } from '../i18n/translations';

import logo from '../images/iit-logo.png';

class Navbar extends Component{

    logOut = (e) => {
        e.preventDefault();
        this.props.logOut();
    }

	render(){

        return(
            <nav className="navbar navbar-inverse">
                <div className="clearfix hotline-bar">
                    <div className="container">
                        <div className="pull-right btn-group language-toggle hidden">
                        {
                            locales.map((locale, index)=>{
                                return(
                                    <button 
                                        key={index} 
                                        className="btn btn-primary" 
                                        onClick={ ()=>{ setLocale(locale) } }>

                                        { locale.name }
                                    </button>
                                )
                            })
                        }
                        </div>
                        <span className="pull-right hotlines">
                            { translations.hotline }: 
                            <span>+255(22) 2132537</span>
                            <span>+255(22) 2116120</span>
                            <span>+255(22) 2116131</span>
                        </span>
                    </div>
                </div>
                <div className="container">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle collapsed" 
                            data-toggle="collapse" data-target="#navbar" aria-expanded="false">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                        <NavLink className="navbar-brand" to="/">
                            <img src={ logo } className="img-responsive" alt="TIIP" />
                        </NavLink>
                    </div>
                    <div className="collapse navbar-collapse" id="navbar">
                        <ul className="nav navbar-nav">
                            <li>
                                <NavLink exact to="/">{ translations.home }</NavLink>
                            </li>
                            <li>
                                <NavLink to="/quote">{ translations.get_a_quote }</NavLink>
                            </li>
                            <li>
                                <NavLink to="/verify-policy">{ translations.verify_policy }</NavLink>
                            </li>
                            <li>
                                <NavLink to="/file-claim">{ translations.file_claim }</NavLink>
                            </li>
                            <li>
                                <NavLink to="/resources">{ translations.resources }</NavLink>
                            </li>
                            <li>
                                <NavLink to="/faqs">{ translations.faqs }</NavLink>
                            </li>
                            <li>
                                <NavLink to="/contact-us">{ translations.contactUs }</NavLink>
                            </li>
                        </ul>
                        { this.props.user.userInfo ? (
                            <ul className="nav navbar-nav navbar-right">
                                <li className="dropdown">
                                    <a className="dropdown-toggle" data-toggle="dropdown" 
                                        role="button" aria-haspopup="true" aria-expanded="false">
                                        <i className="icon ion-person"></i> { this.props.user.userInfo.name } <span className="caret"></span>
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <NavLink to="/dashboard">
                                                <i className="icon ion-home"></i> Dashboard
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/profile">
                                                <i className="icon ion-compose"></i> Profile
                                            </NavLink>
                                        </li>
                                        <li role="separator" className="divider"></li>
                                        <li>
                                            <a onClick={this.logOut}>
                                                <i className="icon ion-android-exit"></i> { translations.logout }
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        ) : (
                            <ul className="nav navbar-nav navbar-right">
                                <li>
                                    <NavLink className="btn btn-nav btn-success" to="/login-register">
                                        { translations.loginOrRegister }
                                    </NavLink>
                                </li>
                            </ul>
                        )}
                    </div>
                </div>
            </nav>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
	user: state.user
});

function mapDispatchToProps(dispatch){
    return bindActionCreators({ logOut }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar.jsx